// versioned curriculum files
// const curriculum = {
//   '0.0.1': require('./curriculum_0.0.1.json'),
// };
let awsCurriculum = {};
let halloweenCurriculum = {};
// For now we always exclude this content. It has not been approved or tested
// before including this content, make sure `halloweenCurriculum` contains `uuid` (data for embedded measurements)
const shouldIncludeBonusCurriculum = false;

const punchlineCurriculum = shouldIncludeBonusCurriculum ?
  {
    ...awsCurriculum,
    itemSets: [{
      standardItems: [
        ...awsCurriculum.itemSets[0].standardItems,
        ...halloweenCurriculum.itemSets[0].standardItems,
      ],
    }],
  } :
  awsCurriculum;

export const setCurriculum = (a) => {
  awsCurriculum = a;
};

export const calculateLevelCount = () => {
  const curriculum = getCurriculum();
  const levelIds = curriculum.itemSets[0].standardItems.map(item => item.level);
  const uniqueLevelIds = Array.from(new Set(levelIds));
  return uniqueLevelIds.length;
};

export const setHalloweenCurriculum = (b) => {
  halloweenCurriculum = b;
};

export const getCurriculum = () => awsCurriculum;

export default punchlineCurriculum;
